import React from 'react';
import './EmailVerification.css';
import Header from '../Header';

const EmailVerification = () => {
    return (
        <div className="email-verification-container">
            <Header /> {/* Include the header */}
            <div className="email-verification-content">
                <div className="email-verification-card">
                    {/* Logo */}
                    <img 
                        src="/pictures/emailverification.png" // Replace with your logo file path 
                        alt="Company Logo" 
                        className="email-verification-logo" 
                    />

                    {/* Title */}
                    <h1 className="email-verification-title">Verify your email address</h1>
                    
                    {/* Description */}
                    <p className="email-verification-description">
                        Please confirm that you want to use this as your account email address. 
                        Once it's done, you’ll be able to start using our platform!
                    </p>
                    
                    {/* Button */}
                    <button className="email-verification-button">Verify my email</button>
                    
                    {/* Link Section */}
                    <p className="email-verification-link-description">
                        Or paste this link into your browser: <br />
                        <span className="email-verification-link">
                            https://yourdomain.com/auth/verify_email/xxxxxxxx
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default EmailVerification;